import axios from 'axios';

/**
 * TODO: 엑세스 토큰 관리 완료 된 경우 tokenIn , tokenInFile 에 있는 토큰 작성 부분 변경해야함.
 */

class AxiosInstance {
  private TIME_OUT = 60 * 1000;

  private BASE_URL = 'https://api.bagoco.in/admin/';

  private static _instance: any;

  public API = axios.create({
    baseURL: this.BASE_URL,
    timeout: this.TIME_OUT
  });

  tokenIn = () => {
    const actRaw = localStorage.getItem('act');
    const csRaw = localStorage.getItem('cs');
    const state = actRaw ? JSON.parse(actRaw).state : {};
    const state2 = csRaw ? JSON.parse(csRaw).state : {};
    const accesstoken = state?.accesstoken;
    const checkSum = state2?.checkSum;

    this.API.defaults.headers.common['accessToken'] = `${accesstoken || ''}`;
    this.API.defaults.headers.common['checkSum'] = `${checkSum || ''}`;
  };

  tokenDelete = () => {
    this.API.defaults.headers.common['authorization'] = ``;
  };

  tokenInFile = () => {
    this.API.defaults.headers.common['authorization'] = `${sessionStorage.getItem('accessToken') || ''
      }`;
    this.API.defaults.headers.common['Content-Type'] = 'multipart/form-data';
  };
}

export default AxiosInstance;
